<template>
	<div>
		<ParticipantCard class="small-video" v-if="!isMain(firstTrack)" :isMain="false" :track="tracks[firstTrack]" :fullControls="true" v-bind="$props" @pin="$emit('pinned', user, firstTrack)"></ParticipantCard>
		<ParticipantCard class="small-video" v-if="firstTrack !== 'screen' && tracks.screen && !isMain('screen')" :isMain="false" :track="tracks.screen" :fullControls="false" v-bind="$props" @pin="$emit('pinned', user, 'screen')"></ParticipantCard>
		<span v-if="!local">
			<AudioTrack v-if="tracks.audio" :track="tracks.audio.track"></AudioTrack>
		</span>
	</div>
</template>


<style lang="less">
	.video-wrapper {
		background-color: #e2e2e2 !important;
		&.has-video{
			background-color: transparent !important;
		}
	}
	.large-video{
		width: 100%;
		min-height: 60vh; 
	}
	.small-video{
		height: 155px;
		overflow-y: hidden;
		display: inline-flex;
		float: left;
		.video-wrapper {
			display: inline-flex;
			width: 280px !important;
		}
	}
</style>

<script type="text/javascript">
	import {createLocalTracks, LocalVideoTrack} from "twilio-video"
	import AudioTrack from "./AudioTrack";
	import ParticipantCard from "./ParticipantCard.vue"
	// import - from "@/components/"
	export default {
		name: "Participant", 
		props: {
			tracks: {}, 
			main: {},
			user: {},
			audio: {}, 
			video: {}, 
			sharing_screen: {}, 
			local: {},
			screenName: {}
		},
		data: () => {
			return {
				screenShared: 0,
			}
		},
		components: {
			AudioTrack,
			ParticipantCard
		},
		computed: {
			firstTrack(){
				if( this.video ){
					return "video" 
				}
				else{
					if( this.sharing_screen ){
						return "screen"
					}
					else{
						return false
					}
				}
			}
		},
		watch: {
			video: {
				immediate: true, 
				handler(){
					this.toggleTrack( "video" )
				}
			},			
			sharing_screen: {
				immediate: true, 
				handler(){
					const self = this;
					if( self.sharing_screen ){
						if( self.local ){
							self.screenShared ++ 
							self.startScreenShare().then((track) => {
								self.$emit("publishNewTrack", self.user, track )	
							})
						}
					}
					else{
						self.toggleTrack("screen")
					}
				}
			},
			audio: {
				immediate: true, 
				handler(){
					this.toggleTrack( "audio" )
				}
			}

		},
		methods: {
			async startScreenShare(){
				const self = this;
				return navigator.mediaDevices.getDisplayMedia().then( stream => {
					const screenTrack = new LocalVideoTrack(stream.getTracks()[0], {name: 'screen-' + self.user + self.screenShared });
					stream.getTracks()[0].onended = function () {
						self.$emit("unsetTrack", self.user, screenTrack )
						self.$emit("endScreenshare", self.user )	
					};
					return screenTrack;
				} ).catch( () => {
					return false
				});
			},		
			toggleTrack( what ){ 
				if( !this[what] ){
					if( this.tracks[what] ){
						if( this.local ){
							this.tracks[what].track.stop()
							this.tracks[what].track.unpublish()
						}
						this.$emit("unsetTrack", this.user, this.tracks[what] )
					}
				}
				else {
					if( this.local ){
						var settings = {};
						settings[what] = true;
						return createLocalTracks(settings).then((tracks) => {
							tracks.forEach( track => {
								this.$emit("publishNewTrack", this.user, track )
							})
						})
					}
				}
			},
			isMain(what){
				if( this.main.user == this.user && this.main.track == what ){
					return true;
				}
				return false
			}
		}
		// created(){
			
		// }

	}
// </script>"